import { type Locale, SUPPORTED_LOCALES } from '@staiter/shared';
import { tokenStorage } from '~/lib/api/client';

/** Decode JWT payload (unsafe — only for client-side claims display). */
export function decodeJwtPayload(token: string): Record<string, unknown> | null {
  try {
    const parts = token.split('.');
    if (parts.length !== 3) return null;
    const payload = parts[1];
    if (!payload) return null;
    // base64url → base64.
    const b64 = payload
      .replace(/-/g, '+')
      .replace(/_/g, '/')
      .padEnd(payload.length + ((4 - (payload.length % 4)) % 4), '=');
    const json = atob(b64);
    return JSON.parse(json) as Record<string, unknown>;
  } catch {
    return null;
  }
}

export function parseJwtLocale(): Locale | null {
  const token = tokenStorage.getAccess();
  if (!token) return null;
  const payload = decodeJwtPayload(token);
  const locale = payload?.locale;
  if (typeof locale === 'string' && (SUPPORTED_LOCALES as readonly string[]).includes(locale)) {
    return locale as Locale;
  }
  return null;
}
